import { createAsyncThunk } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/nextjs";
import { API } from "aws-amplify";
import { KeywordSuggestion } from "./types";

export interface FetchKeywordSuggestionsParams {
  keyword: string;
  locationName?: string;
  languageCode?: string;
}

export const fetchKeywordSuggestions = createAsyncThunk<
  KeywordSuggestion[],
  FetchKeywordSuggestionsParams
>(
  "keywordSuggestions/fetchSuggestions",
  async ({ keyword, locationName = "United States", languageCode = "en" }) => {
    try {


      const response = await API.get(
        "serps",
        "/serps/keyword-suggestions",
        {
          queryStringParameters: {
            keyword: encodeURIComponent(keyword.trim()),
            locationName,
            languageCode,
          },
        }
      );


      if (response.error) {
        throw new Error(response.details || response.error);
      }

      const allSuggestions = response.suggestions || [];

      // Find the exact match for the typed keyword
      const exactMatch = allSuggestions.find((suggestion: KeywordSuggestion) => {
        const originalLower = keyword.toLowerCase().trim();
        const suggestionLower = suggestion.keyword.toLowerCase().trim();
        return suggestionLower === originalLower;
      });

      // Filter out the exact match from other suggestions
      const otherSuggestions = allSuggestions.filter((suggestion: KeywordSuggestion) => {
        const originalLower = keyword.toLowerCase().trim();
        const suggestionLower = suggestion.keyword.toLowerCase().trim();
        return suggestionLower !== originalLower;
      });

      // If we have an exact match, put it first. If not, create a placeholder with null values
      const firstSuggestion = exactMatch || {
        keyword: keyword,
        searchVolume: null,
        keywordDifficulty: null,
        cpc: null,
        competition: null
      };

      return [firstSuggestion, ...otherSuggestions];
    } catch (error) {
      console.error("Error fetching keyword suggestions:", error);
      Sentry.captureException(error);
      throw error;
    }
  }
);